var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingCheckboxBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1572 12.1217 18 10 18C7.87827 18 5.84344 17.1572 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87828 2.84285 5.84345 4.34315 4.34316C5.84344 2.84287 7.87827 2.00001 10 2.00001C10.76 2.00001 11.5 2.11001 12.2 2.31001L13.77 0.740014C12.5743 0.24758 11.2931 -0.00389698 10 1.44178e-05C8.68678 1.44178e-05 7.38642 0.258672 6.17317 0.761219C4.95991 1.26377 3.85752 2.00036 2.92893 2.92895C1.05357 4.80431 0 7.34785 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7363 6.17317 19.2388C7.38642 19.7414 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10M5.91 8.08001L4.5 9.50001L9 14L19 4.00001L17.59 2.58001L9 11.17L5.91 8.08001Z",
    fill: "#002569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingCheckboxBlue);
export default __webpack_public_path__ + "static/media/onboarding-checkbox-blue.41bb418a16ba62f32e09258253182046.svg";
export { ForwardRef as ReactComponent };